<template>
    <v-dialog max-width="600px" v-model="dialogOpen">
        <v-card class="pa-6 pb-0">
            <v-card-title>
                <h1>{{ $t('sendPasswordReset.title') }}</h1>
            </v-card-title>
            <v-form @submit.prevent="sendPasswordResetSubmit">
                <v-card-text>
                    <v-text-field :label="$t('user.email')" v-model="email" prepend-icon="mdi-account-circle" />
                </v-card-text>
                <v-card-actions>
                    <v-container class="pa-2">
                        <v-row class="d-flex ma-0 pb-4">
                            <v-spacer></v-spacer>
                            <v-btn type="submit">
                                {{ $t('common.send') }}
                                <v-progress-circular v-if="pending" indeterminate color="primary"></v-progress-circular>
                            </v-btn>
                        </v-row>
                        <v-row class="d-flex ma-0">
                            <v-alert dismissible type="error" v-model="toggleError" width="100%">
                                {{ $t('sendPasswordReset.error') }}
                            </v-alert>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
import { app } from '@/firebase'
export default Vue.extend({
    name: 'SendPasswordReset',
    props: {
        open: Boolean,
    },
    data: () => ({
        email: '',
        toggleError: false,
        pending: false,
    }),
    computed: {
        dialogOpen: {
            get() {
                return this.open
            },
            set(open) {
                if (!open) this.$emit('close')
            },
        },
    },
    methods: {
        sendPasswordResetSubmit() {
            this.pending = true
            app.functions()
                .httpsCallable('onCallSetPasswordResetEmail')({ email: this.email })
                .then(() => {
                    this.pending = false
                    this.$emit('close')
                    console.log('Email sent.')
                })
                .catch(() => {
                    this.toggleError = true
                })
        },
    },
})
</script>
